import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import styled from 'styled-components';
import { GreenroomState as GS } from '../../../stores/types/types';
import colors from '../../../utils/colors';
import { StreamSettingLocation } from './streaming-settings';

const DestinationSelectedSpan = styled.span`
	font-size: 14px;
	font-weight: 500;
	line-height: 24px;
	transition: color 500ms;
	color: ${colors.blGrayscale400};

	&.show-details {
		font-size: 14px;
		font-weight: 600;
		line-height: 20px;	
	}

	&.max {
		color: ${colors.blSemanticRed400};
	}
`;

export const MAX_TOGGLED = 5;
interface Props { location: StreamSettingLocation; }

export default function DestinationCount({ location }: Props) {
	const destinations = useSelector((state: GS) => state.BroadcastReducer.destinations);

	const isShowDetails = useMemo(() => location === StreamSettingLocation.ShowDetails, [location]);
	const toggled = useMemo(() => destinations.filter(({ selected: s }) => s).length, [destinations]);

	return (
		<DestinationSelectedSpan
			className={classNames({ max: toggled >= MAX_TOGGLED, 'show-details': isShowDetails })}
		>
			{isShowDetails && <>&nbsp;</>}
			{isShowDetails ? ` (${toggled}/${MAX_TOGGLED})` : `${toggled} out of ${MAX_TOGGLED}`}
		</DestinationSelectedSpan>
	);
}
